import {Component, HostBinding, Input, ViewEncapsulation} from '@angular/core';
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {NotificationStore} from "../notification.store";
import {Observable} from "rxjs";

@Component({
  selector: 'app-notification-template',
  templateUrl: './notification-template.component.html',
  styleUrls: ['./notification-template.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationTemplateComponent {
  @HostBinding('class') public css_class: string;

  public type: string = 'info';
  @Input('type') public set set_type(type: string) {
    this.type = type;
    this.css_class = type;
  }

  @Input() public notification: NotificationComponentObject;

  public readonly loading$: Observable<boolean> = this._notificationStore.loading$;

  constructor(
    private readonly _notificationStore: NotificationStore
  ) {}

  public markAsRead(): void {
    this._notificationStore.markAsRead({ notification: this.notification, closeMenu: false });
  }

}
